/**
 * « Annuler » — a small "you can take that back" bus.
 *
 * Anything that changes data can offer an undo without knowing the toaster
 * exists: it calls pushUndo() with a label and the function that reverts the
 * change. The toaster, mounted once inside the Actes section, listens and
 * stacks the toasts. Keeping it an event is what avoids threading a provider
 * through every table, modal and row action.
 */
export type UndoAction = {
  /** One line: what just happened ("Statut modifié"). */
  label: string;
  /** Optional second line for context ("Jean DUPONT · Reçu → Non abouti"). */
  detail?: string;
  /** Reverts the change. May be async; an error surfaces on the toast. */
  undo: () => Promise<void> | void;
};

export function pushUndo(action: UndoAction): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<UndoAction>('actes:undo', { detail: action }));
}
